<template>
  <div class="app-footer app-width">
    <div class="footer-toolbar app-center">
      <div class="footer-inner f-flex f-row f-nowrap f-justify-space-betwen f-flex-start">
        <!-- <div class="item copyright">
          <p class="bold">&copy; 2012 - {{ new Date().getFullYear() }} KnuVu. All rights reserved</p>
          <router-link to="/">
            <img alt="Logo" src="../../assets/logos/logo-full.png" class="logo" />
          </router-link>
        </div>-->
        <div class="item link">
          <p class="bold"><router-link to="/">Website</router-link></p>
          <!-- <router-link to="/">Home</router-link> -->
        </div>
        <div class="item link">
          <p class="bold"><router-link to="/methodology">Methodology</router-link></p>
          <!-- <router-link to="/methodology">Methodology</router-link> -->
        </div>
        <div class="item link">
          <p class="bold"><router-link to="/corporate-development">Corporate Development</router-link></p>
          <!-- <router-link to="/corporate-development">Corporate Development</router-link> -->
        </div>
        <div class="item link">
          <p class="bold"><router-link to="/services">Strategy, Professional, Transactional Services</router-link></p>
          <router-link to="/consulting">Strategy Consulting</router-link>
          <!-- <router-link to="/services">Applied Methodology Services</router-link> -->
          <!-- <router-link to="/services">Transactional Services</router-link> -->
        </div>
        <div class="item link">
          <p class="bold"><router-link to="/about">About KnuVu</router-link></p>
          <!-- <router-link to="/about">About</router-link> -->
          <router-link to="/team">Team</router-link>
          <router-link to="/advisors">Advisors</router-link>
          <router-link to="/contact">Contact Us</router-link>
        </div>
      </div>
      <div class="footer-copyright">
        <p class="bold">&copy; 2012 - {{ new Date().getFullYear() }} KnuVu, LLC</p>
        <router-link to="/">
          <img alt="Logo" src="../../assets/logos/logo-full.png" class="logo" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.app-footer {
  margin-top: 32px;
  padding: 32px 0 24px 0;
  min-height: 100px;
  text-shadow: 1px 1px 1px rgb(255, 255, 255);
  -webkit-box-shadow: inset 0px 10px 30px -30px rgba(0, 0, 0, 1);
  -moz-box-shadow: inset 0px 10px 30px -30px rgba(0, 0, 0, 1);
  box-shadow: inset 0px 10px 30px -30px rgba(0, 0, 0, 1);

  div.footer-toolbar {
    div.footer-inner {
      div.item {
        &.link {
          > * {
            display: block;
            margin-top: 8px;
          }
        }

        // img.logo {
        //   width: 100px;
        //   margin-top: 16px;
        // }
      }
    }

    div.footer-copyright {
      text-align: center;
      margin-top: 16px;
      img.logo {
        width: 100px;
        margin-top: 16px;
      }
    }
  }

  a:link,
  a:visited,
  a:link:active,
  a:visited:active {
    color: #5e5e5e;

    &:hover {
      color: #4694c2;
      cursor: pointer;
    }
  }
}
</style>
